export default {
  getStatus(state) {
    return id => {
      return state.statuses.find(item => item.id === id)
    }
  },
  getTypes(state) {
    return id => {
      return state.types.find(item => item.id === id)
    }
  },
  getGroups(state) {
    return id => {
      return state.types.find(item => item.id === id)
    }
  }
}
